import { Contact } from "../_types/internalContacts.types";

const CALLABLE_CONTACT_TYPES = ["workforce", "organizationCoworker"];

export const isCallableContact = (contact: Contact | null): boolean => {
  return contact ? CALLABLE_CONTACT_TYPES.includes(contact.type) : false;
};

const getContactUserUid = (contact: Contact): string | null => {
  if (!contact) return null;

  // Always prefer userUid (the actual User UID)
  if (contact.userUid) return contact.userUid;

  // Fallback to contact uid (could be workforce uid if no User linked)
  return contact.uid;
};

/**
 * WebRTC presence and notifications are keyed by User UID.
 * Workforce contacts without a linked user account cannot be called.
 */
export const resolveReceiverUserUid = (contact: Contact): string | null => {
  if (contact.userUid) return contact.userUid;
  if (contact.type === "organizationCoworker" && contact.uid) return contact.uid;
  return null;
};

export interface BuildCallRoomNameParams {
  companyId: number;
  callerUid: string;
  contact: Contact;
}

export const buildCallRoomName = ({
  companyId,
  callerUid,
  contact,
}: BuildCallRoomNameParams): string | null => {
  const peerUid = resolveReceiverUserUid(contact) ?? getContactUserUid(contact);

  if (!companyId || !callerUid || !peerUid) {
    console.warn("[CallRoom] Missing params:", {
      companyId,
      callerUid,
      peerUid,
      contactType: contact?.type,
    });
    return null;
  }

  // Sort to ensure A→B and B→A generate same room
  const participants = [callerUid, peerUid].sort();
  const roomName = `call:${companyId}:${participants.join(":")}`;

  console.log("[CallRoom] Generated:", roomName, {
    callerUid,
    peerUid,
    contactType: contact?.type,
  });

  return roomName;
};
